import React from 'react';
import './Features.css';
import { useTranslation } from 'react-i18next';

// Defining the structure for a feature item
interface Feature {
  id: number;
  icon: string;
  title: string;
  description: string;
}

const Features: React.FC = () => {
  const { t } = useTranslation();

  // A more detailed and compelling list of features
  const features: Feature[] = [
    {
      id: 1,
      icon: '🤖',
      title: t('features.feature1_title'),
      description: t('features.feature1_description')
    },
    {
      id: 2,
      icon: '📦',
      title: t('features.feature2_title'),
      description: t('features.feature2_description')
    },
    {
      id: 3,
      icon: '🎯',
      title: t('features.feature3_title'),
      description: t('features.feature3_description')
    },
    {
      id: 4,
      icon: '🎥',
      title: t('features.feature4_title'),
      description: t('features.feature4_description')
    },
    {
      id: 5,
      icon: '📊',
      title: t('features.feature5_title'),
      description: t('features.feature5_description')
    },
    {
      id: 6,
      icon: '🍽️',
      title: t('features.feature6_title'),
      description: t('features.feature6_description')
    }
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="features-header">
          <h2 className="section-title">{t('features.title')}</h2>
          <p className="section-subtitle">
            {t('features.subtitle')}
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="feature-card">
              <div className="feature-icon">
                <span>{feature.icon}</span>
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
